import React from 'react';
import { Paper, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles, styled } from '@material-ui/core/styles';

import { HomeH2 } from '@bizapp-lp/workflow/molecules/Heading';
import { StyledButton } from '@bizapp-lp/workflow/molecules/StyledButton';

export interface PlanProps {
  className?: string;
  onClick1?: () => void;
  onClick2?: () => void;
}

const Component: React.FC<PlanProps> = ({ className, onClick1, onClick2 }) => {
  const classes = makeStyles((theme: Theme) =>
    createStyles({
      sectionHeading: {
        margin: theme.spacing(0, 'auto', 8),
      },
    }),
  )();

  const RootContainer = styled('section')(({ theme }) => ({
    padding: theme.spacing(32, 2, 5),
    background:
      'transparent linear-gradient(90deg, #0EC6BD 0%, #78DB99 100%) 0% 0% no-repeat padding-box',
    transform: 'skewY(-10deg)',
    '& > *': {
      transform: 'skewY(10deg)',
    },
  }));

  const ContentBox = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up(960)]: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      margin: theme.spacing(0, 'auto'),
    },
  }));

  const PricePaper = styled(Paper)(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '480px',
    boxShadow: '0px 8px 16px #0000004D',
    boxSizing: 'border-box',
    border: '1px solid #DADDE0',
    borderRadius: '6px',
    textAlign: 'center',
    marginBottom: theme.spacing(8),
    padding: theme.spacing(4, 2, 5),
    [theme.breakpoints.up(480)]: {
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
    },
    [theme.breakpoints.up(960)]: {
      marginBottom: 'initial',
    },
  }));

  const PriceImgBox = styled('div')(({ theme }) => ({
    '& > img': {
      width: '80px',
    },
  }));

  const PriceHeadingComponent = styled('h3')(({ theme }) => ({
    color: '#333333',
    fontSize: '28px',
    lineHeight: '42px',
    fontWeight: 'bold',
    letterSpacing: 0,
    marginTop: theme.spacing(4),
    [theme.breakpoints.up(768)]: {
      fontSize: '32px',
      lineHeight: '48px',
    },
  }));

  const PriceDescriptionComponent = styled('p')(({ theme }) => ({
    marginTop: theme.spacing(4),
    fontSize: '16px',
    '& span': { display: 'block' },
  }));

  const PriceComponent = styled('p')(({ theme }) => ({
    margin: theme.spacing(4, 0),
    color: '#0ec6bd',
    fontSize: '40px',
  }));

  const PriceNoteComponent = styled('p')(({ theme }) => ({
    color: '#7F7F7F',
    fontSize: '14px',
    '& span': { display: 'block' },
    '& small': {
      fontSize: '14px',
      display: 'block',
    },
  }));

  const NavigationBox = styled('div')(({ theme }) => ({
    width: '100%',
    maxWidth: '240px',
    '& > button': {
      width: '100%',
      height: '48px',
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.up(960)]: {
      margin: theme.spacing(0, 8, 5),
    },
  }));

  const NavigationTextComponent = styled('p')(({ theme }) => ({
    color: '#ffffff',
    margin: theme.spacing(2, 0, 1),
    '& span': { display: 'block' },
  }));

  return (
    <RootContainer className={className}>
      <HomeH2 variant="white" className={classes.sectionHeading}>
        料金プラン
      </HomeH2>
      <ContentBox>
        <PricePaper>
          <PriceImgBox>
            <img
              src={`${process.env.PUBLIC_URL}/images/workflow.png`}
              alt={'Workflow Icon'}
            />
          </PriceImgBox>
          <Typography component={PriceHeadingComponent}>Workflow</Typography>
          <Typography component={PriceDescriptionComponent}>
            <span>ワークフローを簡単に運用したい</span>
            <span>部門・会社におすすめのプランです。</span>
          </Typography>
          <Typography component={PriceComponent}>&yen;330</Typography>
          <Typography component={PriceNoteComponent}>
            １ユーザーあたり月額（税込）
          </Typography>
        </PricePaper>
        <NavigationBox>
          <Typography component={NavigationTextComponent}>
            <span>
              サービスや運用の詳細資料を、下記よりダウンロードしていただけます。
            </span>
            <span>
              お客様の要件に合わせた、導入や運用のご相談も承っておりますので、お気軽にご相談ください。
            </span>
          </Typography>
          <StyledButton
            variant="secondary"
            label="資料ダウンロード"
            onClick={onClick1}
          />
          <StyledButton
            variant="secondary"
            label="お問い合わせ"
            onClick={onClick2}
          />
        </NavigationBox>
      </ContentBox>
    </RootContainer>
  );
};

export const Plan = React.memo(Component);
